import React from 'react'
import Header from '../../HomePage/Header/Header'
import RegisterContent from './RegisterContent'
import Footer from '../../HomePage/Footer/Footer'
import FeedbackForm from '../../FeedbackForm/FeedbackForm'

const Register = () => {
    return (
        <div>
            <FeedbackForm />
            <Header />
            <RegisterContent />
            <Footer />
        </div>
    )
}

export default Register